import { Point, Shape } from "../RampCanvasV2/RampCanvasV2";

/**
 * Types of transform handles
 */
export type HandleType =
  // Corner handles for proportional scaling
  | "corner-nw"
  | "corner-ne"
  | "corner-se"
  | "corner-sw"
  // Edge handles for single-axis resizing
  | "edge-n"
  | "edge-e"
  | "edge-s"
  | "edge-w"
  // Rotation handle
  | "rotate";

/**
 * A transform handle with position and metadata
 */
export interface TransformHandle {
  type: HandleType;
  x: number;
  y: number;
  width: number;
  height: number;
  cursor: string;
}

/**
 * Bounding box for selected shapes (axis-aligned)
 */
export interface BoundingBox {
  minX: number;
  minY: number;
  maxX: number;
  maxY: number;
  centerX: number;
  centerY: number;
  width: number;
  height: number;
}

/**
 * Transform operation state
 */
export interface TransformOperation {
  type: HandleType;
  startMousePos: Point;
  startBounds: BoundingBox;
  startShapePoints: Map<string, Point[]>;
}

/**
 * Cursor styles for each handle type
 */
export const HANDLE_CURSORS: Record<HandleType, string> = {
  "corner-nw": "nwse-resize",
  "corner-ne": "nesw-resize",
  "corner-se": "nwse-resize",
  "corner-sw": "nesw-resize",
  "edge-n": "ns-resize",
  "edge-s": "ns-resize",
  "edge-e": "ew-resize",
  "edge-w": "ew-resize",
  rotate: "grab",
};

/**
 * Handle size in pixels (before zoom adjustment) for corner/edge handles
 */
export const HANDLE_SIZE = 8;

/**
 * Rotation handle size in pixels (before zoom adjustment) - larger for easier interaction
 */
export const ROTATION_HANDLE_SIZE = 28;

/**
 * Rotation handle offset from top of bounding box
 */
export const ROTATION_HANDLE_OFFSET = 24;
